import React from 'react';
import { Skeleton } from 'antd';
import { AdminSettingsPageProps } from './AdminSettingsPageProps';

const AdminSettingsPage = React.lazy(() => import('./AdminSettingsPage'));

export const AsyncAdminSettingsPage: React.FC<AdminSettingsPageProps> = props => {
	return (
		<React.Suspense
			fallback={<Skeleton active paragraph={{ rows: 4 }} title={{ width: '100%' }} />}
		>
			<AdminSettingsPage {...props} />
		</React.Suspense>
	);
};
